import React, { useEffect, useState } from "react";
import CustomCreatableMultiSelect from "../../common/CustomCreatableMultiSelect";
import useDebounce from "../../common/debounce";
import { getMedicalTermList } from "../../ERXViewApiHandler";
import {
  GET_FAMILY_HISTORY_LIST,
  GET_LIFESTYLE_LIST,
  GET_MEDICAL_TERM_LIST,
  GET_MENSTRUAL_LIST,
  GET_PAST_MEDICAL_HISTORY_LIST,
  SAVE_CUSTOM_CHIEF_COMPLAINT,
  SAVE_CUSTOM_FAMILY_HISTORY,
  SAVE_CUSTOM_LIFESTYLE_HISTORY,
  SAVE_CUSTOM_MENSTRUAL_HISTORY,
  SAVE_CUSTOM_PAST_MEDICAL_HISTORY,
} from "../../ERXViewApiHandler/apiConstants";
import "./phcView.scss";
import TitleWithBorder from "../../common/TitleWithBorder";
import { CUSTOM_BUTTON_STATUS } from "../../ERXConstants/constants";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import FormInputWithHeader from "../../../common/FormInputWithHeader";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

const PHCView = (props) => {
  const {
    element,
    patient_history_and_complaints,
    phcSuggestionObj,
    prescription_id,
    obstetricHistoryList,
    handlePatientHistoryAndComplaints,
    updatedGender,
    handleUpdateAPICall,
    handleOnChangeObstetricHistory,
  } = props;

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const debounceForPatirntHistory = useDebounce(
    patient_history_and_complaints,
    500
  );

  const debounceForObstetricHistory = useDebounce(obstetricHistoryList, 500);

  const [maxApiCall, setMaxApiCall] = useState(1);
  const [pageNo, setPageNo] = useState(1);
  const [key, setKey] = useState("");
  const [suggestionList, setSuggestionList] = useState({});

  useEffect(() => {
    if (
      debounceForPatirntHistory?.call_api ||
      debounceForObstetricHistory?.call_api
    ) {
      handleUpdateAPICall();
    }
  }, [debounceForPatirntHistory, debounceForObstetricHistory]);

  useEffect(() => {
    setPageNo(1);
  }, [key]);

  useEffect(() => {
    let data = [...patient_history_and_complaints.value];
    Object.entries(phcSuggestionObj).length > 0 &&
      Object.entries(phcSuggestionObj).forEach(
        ([key_value, phcSuggestionList]) => {
          if (phcSuggestionList?.length > 0) {
            let phIndex = data?.findIndex((val) => val.name === key_value);
            if (phIndex > -1) {
              phcSuggestionList.forEach((item) => {
                let filterData = data[phIndex]?.value?.filter(
                  (d) => d.value.toLowerCase() === item.title.toLowerCase()
                );
                item.selected = filterData?.length !== 0;
              });
            }
          }
          setSuggestionList({ ...phcSuggestionObj });
        }
      );
  }, [patient_history_and_complaints, phcSuggestionObj]);

  const getMedicalTermListAPICall = async (key, searchString, pageNo, type) => {
    let reqParams = {
      search_string: searchString,
      page_no: pageNo,
      doctor_id: userId,
    };
    const medicalTermListResponse = getMedicalTermList(
      getAPIEndPoint(key),
      reqParams
    ); //Fetch API Data
    medicalTermListResponse.then(([res, count, error]) => {
      let data = [...patient_history_and_complaints.value];
      let index = data.findIndex((data) => data.name === key);
      if (!error) {
        if (res?.length > 0) {
          if (index > -1) {
            if (type === "search") {
              data[index].options = [...res];
            } else {
              data[index].options = [...data[index].options, ...res];
            }

            data[index].menuIsOpen =
              data[index].options?.length > 0 ? true : false;
            let maxCount = Math.ceil(count / 20);
            setMaxApiCall(maxCount);
            if (data[index]?.options?.length > 0) {
              let indexKey = data[index].value.findIndex(
                (item) =>
                  item?.value?.trim()?.toLowerCase() ===
                  data[index]?.options[0]?.value?.trim()?.toLowerCase()
              );
              if (indexKey > -1) {
                if (data[index]?.options[0]?.knowledge_base_id) {
                  data[index].value[indexKey].knowledge_base_id =
                    data[index]?.options[0].knowledge_base_id;
                  data[index].value[indexKey].button_status = "";
                } else if (data[index]?.options[0]?.master_id) {
                  data[index].value[indexKey].master_id =
                    data[index]?.options[0].master_id;
                  data[index].value[indexKey].button_status = "";
                } else {
                  data[index].value[indexKey].button_status =
                    CUSTOM_BUTTON_STATUS.SAVE;
                }
              }
            }
            handlePatientHistoryAndComplaints([...data]);
          }
        } else {
          data[index].options = [];
          data[index].menuIsOpen = false;
          handlePatientHistoryAndComplaints([...data]);
        }
      } else {
        data[index].options = [];
        data[index].menuIsOpen = false;
        handlePatientHistoryAndComplaints([...data]);
      }
    });
  };

  const handleSearch = (key, value, pageno, type) => {
    setKey(key);
    if (value?.length > 0) {
      getMedicalTermListAPICall(key, value, pageno, type);
    } else {
      setMaxApiCall(0);
      setPageNo(1);
      let data = [...patient_history_and_complaints.value];
      let index = data.findIndex((data) => data.name === key);
      if (index > -1) {
        data[index].options = [];
        data[index].menuIsOpen = false;
        handlePatientHistoryAndComplaints([...data]);
      }
    }
  };

  const handleSelect = (key, value) => {
    let data = [...patient_history_and_complaints.value];
    let index = data.findIndex((data) => data.name === key);

    let isValueDuplicate = data[index].value.filter(
      (ele) =>
        ele.value?.trim()?.toLowerCase() === value?.value?.trim()?.toLowerCase()
    );
    if (index > -1) {
      if (data[index].value.length > 0) {
        if (isValueDuplicate.length === 0) {
          value["id"] = data[index].value[data[index].value.length - 1].id + 1;
        }
      } else {
        value["id"] = 1;
      }
      if (value?.id) {
        data[index].options = [];
        data[index].value = [...data[index].value, value];
        data[index].menuIsOpen = false;
        if (value?.capture_painscale) {
          data[index].showPainScale = true;
        }
        handlePatientHistoryAndComplaints([...data]);
      }
    }
  };

  const handleOnChange = (key, value) => {
    let data = [...patient_history_and_complaints.value];
    let index = data.findIndex((data) => data.name === key);
    if (index > -1) {
      data[index].options = [];
      data[index].menuIsOpen = false;
      data[index].value = value;
      handlePatientHistoryAndComplaints([...data]);
    }
  };

  const handlePageNumber = (key, value, pageNo) => {
    getMedicalTermListAPICall(key, value, pageNo);
  };

  const getAPIEndPoint = (key) => {
    switch (key) {
      case "menstrual_history":
        return GET_MENSTRUAL_LIST;
      case "lifestyle_history":
        return GET_LIFESTYLE_LIST;
      case "past_medical_history":
        return GET_PAST_MEDICAL_HISTORY_LIST;
      case "family_history":
        return GET_FAMILY_HISTORY_LIST;
      default:
        return GET_MEDICAL_TERM_LIST;
    }
  };

  const handlePainScaleSelect = (key, value) => {
    let data = [...patient_history_and_complaints.value];
    let index = data.findIndex((data) => data.name === key);
    if (index > -1) {
      data[index].options = [];
      data[index].menuIsOpen = false;
      data[index].value = value;
      handlePatientHistoryAndComplaints([...data]);
    }
  };

  const handlePainScaleInput = (key, value) => {
    let data = [...patient_history_and_complaints.value];
    let index = data.findIndex((data) => data.name === key);
    if (index > -1) {
      data[index].menuIsOpen = false;
      data[index].options = [];
      data[index].value = value;
      handlePatientHistoryAndComplaints([...data]);
    }
  };

  const handlePainScale = (key, value) => {
    let data = [...patient_history_and_complaints.value];
    let index = data.findIndex((data) => data.name === key);
    if (index > -1) {
      data[index].options = [];
      data[index].menuIsOpen = false;
      data[index].value = value;
      handlePatientHistoryAndComplaints([...data]);
    }
  };

  const handleCustomInput = (name, value) => {
    let obj = {
      ...value,
      title: value?.value,
      capture_painscale: false,
      button_status:
        value?.knowledge_base_id || value?.master_id
          ? ""
          : CUSTOM_BUTTON_STATUS.SAVE,
    };
    handleSelect(name, obj);
  };

  const handleSuggestionClick = (suggestion, name) => {
    if (!suggestion?.selected) {
      let data = [...patient_history_and_complaints.value];
      let index = data.findIndex((data_index) => data_index.name === name);

      if (index > -1) {
        let isValueDuplicate = data[index]?.value?.filter(
          (ele) =>
            ele?.value?.trim()?.toLowerCase() ===
            suggestion?.title?.toLowerCase()
        );
        let id = null;
        if (data[index]?.value?.length > 0) {
          if (isValueDuplicate.length === 0) {
            id = data[index]?.value[data[index]?.value?.length - 1].id + 1;
          }
        } else {
          id = 1;
        }
        if (id) {
          let obj = {
            id: id,
            value: suggestion?.title,
            ...(suggestion?.master_id && { master_id: suggestion?.master_id }),
            ...(suggestion?.knowledge_base_id && {
              knowledge_base_id: suggestion?.knowledge_base_id,
            }),
          };
          handleCustomInput(name, obj);
        }
      }
    }
  };

  const handleSaveCustomData = (name, id) => {
    let data = [...patient_history_and_complaints.value];
    let index = data.findIndex(
      (dataIndexValue) => dataIndexValue.name === name
    );
    if (index > -1) {
      let dataIndex = data[index].value.findIndex(
        (dataIndexValue) => dataIndexValue.id === id
      );
      data[index].value[dataIndex].button_status = CUSTOM_BUTTON_STATUS.LOADING;
      handlePatientHistoryAndComplaints([...data]);
      let requestPayload = {
        "authorizer-principal-id": { user_type: "1" },
        prescription_id: prescription_id,
        doctor_id: userId,
        title: data[index].value[dataIndex].title,
      };
      const saveCustomDataResponse = c2cPostApiHandler(
        getSaveCustomDataAPI(name),
        requestPayload
      ); //Fetch API Data
      saveCustomDataResponse.then(([res, error]) => {
        if (!error) {
          if (res?.data?.statusCode === 200) {
            let responseData = { ...res?.data };
            setTimeout(() => {
              data[index].value[dataIndex]["knowledge_base_id"] =
                responseData?.knowledge_base_id;
              data[index].value[dataIndex].button_status =
                CUSTOM_BUTTON_STATUS.SUCCESS;
              handlePatientHistoryAndComplaints([...data]);
            }, 2000);
          } else {
            triggerErrorLoader(name, id);
          }
        } else {
          triggerErrorLoader(name, id);
        }
      });
    }
  };

  const getSaveCustomDataAPI = (keyName) => {
    switch (keyName) {
      case "menstrual_history":
        return SAVE_CUSTOM_MENSTRUAL_HISTORY;
      case "lifestyle_history":
        return SAVE_CUSTOM_LIFESTYLE_HISTORY;
      case "past_medical_history":
        return SAVE_CUSTOM_PAST_MEDICAL_HISTORY;
      case "family_history":
        return SAVE_CUSTOM_FAMILY_HISTORY;
      default:
        return SAVE_CUSTOM_CHIEF_COMPLAINT;
    }
  };

  const triggerErrorLoader = (name, id) => {
    let data = [...patient_history_and_complaints.value];
    let index = data.findIndex((indexData) => indexData.name === name);
    if (index > -1) {
      let dataIndex = data[index].value.findIndex(
        (dataIndexValue) => dataIndexValue.id === id
      );
      data[index].value[dataIndex].button_status = CUSTOM_BUTTON_STATUS.ERROR;
      handlePatientHistoryAndComplaints([...data]);
      setTimeout(() => {
        data[index].value[dataIndex].button_status = CUSTOM_BUTTON_STATUS.SAVE;
        handlePatientHistoryAndComplaints([...data]);
      }, 2000);
    }
  };

  //  <====  UI

  const renderSuggestionUI = (name) => {
    return (
      <div className="suggestion-container">
        {suggestionList[name]?.map((data, index) => (
          <div className="suggestion-wrapper" key={index}>
            <TitleWithBorder
              key={index}
              title={data?.title}
              selected={data?.selected}
              hoverTitleSize={30}
              handleClick={() => handleSuggestionClick(data, name)}
            />
          </div>
        ))}
      </div>
    );
  };

  const displayObstetricHistory = () => {
    return (
      <>
        <div className="custom-creatable-multi-select-title">
          {" "}
          Obstetric History
        </div>
        <div className="obsteric-display ">
          {obstetricHistoryList?.value?.map(
            (item) =>
              item?.label !== "obstetric_note" && (
                <div key={item.id} className="obsteric-title">
                  <FormInputWithHeader
                    title={item.title}
                    type={item.type}
                    placeholder={item.placeholder}
                    value={item.value}
                    handleOnChangeInput={(e) =>
                      handleOnChangeObstetricHistory(item, e)
                    }
                  />
                </div>
              )
          )}
        </div>
        <div className="obsteric-string-display">
          {obstetricHistoryList?.value?.map(
            (item) =>
              item?.label === "obstetric_note" && (
                <div key={item.id}>
                  <FormInputWithHeader
                    title={item.title}
                    type={item.type}
                    placeholder={item.placeholder}
                    value={item.value}
                    handleOnChangeInput={(e) =>
                      handleOnChangeObstetricHistory(item, e)
                    }
                  />
                </div>
              )
          )}
        </div>
      </>
    );
  };

  //  ======>
  let finalPatientHistoryList = [];
  let historySettings = ["chief_complaints"];
  element.settings.forEach((data) => {
    if (data?.answer) {
      historySettings.push(data.que_key);
    }
  });

  patient_history_and_complaints.value.forEach((data) => {
    if (
      data.showFor.includes(updatedGender?.toLowerCase()) &&
      historySettings?.includes(data?.name)
    ) {
      finalPatientHistoryList.push(data);
    }
  });

  let isOdd = finalPatientHistoryList?.length % 2 == 1;

  return (
    <div id={element.name} className="phc-view-container">
      {/* PHC Component */}

      {finalPatientHistoryList?.map((data, ind) => (
        <div
          key={ind}
          className={
            "phc-components " +
            (isOdd && finalPatientHistoryList.length - 1 === ind
              ? "phc-components-full-width"
              : "phc-components-half-width")
          }
        >
          {data.inputLabel === "Obstetric History" ? (
            <div>{displayObstetricHistory()}</div>
          ) : (
            <CustomCreatableMultiSelect
              inputLabel={data?.inputLabel}
              options={data?.options}
              menuIsOpen={data?.menuIsOpen}
              value={data?.value}
              name={data?.name}
              handleSearch={handleSearch}
              handleSelect={handleSelect}
              handleOnChange={handleOnChange}
              handlePainScaleSelect={handlePainScaleSelect}
              handlePainScaleInput={handlePainScaleInput}
              handlePainScale={handlePainScale}
              maxApiCall={maxApiCall}
              setPageNo={setPageNo}
              pageNo={pageNo}
              closeMenu={(name) => {
                let duplicated = [...patient_history_and_complaints.value];
                let b = patient_history_and_complaints?.value?.forEach(
                  (obj) => (obj.menuIsOpen = obj.name === name && false)
                );
                handlePatientHistoryAndComplaints([...duplicated]);
              }}
              handleCustomInput={handleCustomInput}
              hasCustomSaveButton={data?.hasCustomSaveButton}
              handleSaveCustomData={handleSaveCustomData}
            />
          )}

          {suggestionList[data?.name]?.length > 0 &&
            renderSuggestionUI(data?.name)}
        </div>
      ))}
    </div>
  );
};

export default PHCView;
